import cn from 'classnames'
import { useContext } from 'preact/hooks'
import { Recovery } from './index'
import styles from './StepSwitcher.module.css'

const StepSwitcher = () => {
  const { type, switchType } = useContext(Recovery)

  const tabHandler = (tabType) => {
    switchType(tabType)
  }

  return (
    <div className={styles.recovery}>
      <div className={styles.recovery__tabs}>
        <div
          className={cn(styles.recovery__tab, {
            [styles.recovery__tab_selected]: type === 'phone',
          })}
          onClick={() => tabHandler('phone')}
        >
          По телефону
        </div>
        <div
          className={cn(styles.recovery__tab, {
            [styles.recovery__tab_selected]: type === 'email',
          })}
          onClick={() => tabHandler('email')}
        >
          По email
        </div>
      </div>
    </div>
  )
}

export default StepSwitcher
